export type Calculation = {
  netProfit: number;
  totalReturn: number;
  maxLoss: number;
  breakEvenRate: number;
};

export type ValidationResult =
  | { valid: true; amount: number; payoutRate: number }
  | { valid: false; amountError?: string; rateError?: string };

const MAX_AMOUNT = 1_000_000_000;

export function validateCalculatorInputs(
  amountInput: string,
  rateInput: string,
): ValidationResult {
  const amount = Number(amountInput);
  const payoutRate = Number(rateInput);
  const amountError =
    amountInput.trim() === ""
      ? "请输入交易金额"
      : !Number.isFinite(amount)
        ? "请输入有效数字"
        : amount <= 0
          ? "金额必须大于 0"
          : amount > MAX_AMOUNT
            ? "金额过大，请输入不超过 10 亿的数值"
            : undefined;
  const rateError =
    rateInput.trim() === ""
      ? "请输入回报率"
      : !Number.isFinite(payoutRate)
        ? "请输入有效数字"
        : payoutRate <= 0
          ? "回报率必须大于 0"
          : payoutRate > 100
            ? "请输入官网显示的回报率（不超过 100%）"
            : undefined;

  if (amountError || rateError) {
    return { valid: false, amountError, rateError };
  }

  return { valid: true, amount, payoutRate };
}

export function calculateOutcome(
  amount: number,
  payoutRatePercent: number,
): Calculation {
  const payoutRate = payoutRatePercent / 100;
  const netProfit = amount * payoutRate;

  return {
    netProfit,
    totalReturn: amount + netProfit,
    maxLoss: amount,
    breakEvenRate: 1 / (1 + payoutRate),
  };
}
